<template>
  <div class="container">
      <div class="topView">
          <img class="topViewBg" src="../../assets/images/parkingTopBg.png"/>
          <div class="topViewdiv">
              <div class="topView_item">
                   <img class="topView_item_icon" src="../../assets/images/icon_parking_company.png" />
                   <span class="topView_item_span">{{defaultTenant.company}}</span>
              </div>
              <div class="topView_item1">
                  <img class="topView_item_icon" src="../../assets/images/icon_discount_p.png" />
                   <span class="topView_item_span">{{common.userTenantInfo.userName}}</span>
              </div>
          </div>
          <div class="topView_chakan" @click="toList()">
              <span class="topView_chakan_span">查看申请详情</span>
              <img class="topView_chakan_icon" src="../../assets/images/icon_indicator_next.png" />
          </div>
      </div>
      <div class="chooseDate">
          <div class="dateTop">
              <span class="dateTop_span">填写申请信息</span>
          </div>
          <div class="dateItem">
              <div class="dateItem_left">
                <span class="dateItem_left_span1">开始时间</span>
                <span class="dateItem_left_span2">*</span>
              </div>
              <div class="dateItem_right"  @click="selectTime(1)">
                    <span :class="['dateItem_right_span1', startTime ?'blackSpan' :'']" >{{startTime?startTime:'请选择开始时间' }}</span>
                    <img class="dateItem_right_icon" src="../../assets/images/icon_indicator_next.png" />
              </div>
          </div>
          <div class="itemLine"></div>
           <div class="dateItem">
              <div class="dateItem_left">
                <span class="dateItem_left_span1">结束时间</span>
                <span class="dateItem_left_span2">*</span>
              </div>
              <div class="dateItem_right" @click="selectTime(2)" >
                    <span :class="['dateItem_right_span1', endTime ?'blackSpan' :'']"  >{{endTime?endTime:'请选择结束时间' }}</span>
                    <img class="dateItem_right_icon" src="../../assets/images/icon_indicator_next.png" />
              </div>
          </div>
      </div>
      <div class="cardBg">
         <card-number come="add" @inputChange="inputChange" :mustImg="mustImg"></card-number>
      </div>

       <div class="footButton">
            <div class="footButton1_div" v-if=" validateParams()==false" >
                <span class="parkingDiscountfootButton_Span">立即申请</span>
            </div>
            <div class="parkingDiscountfootButton2_div" v-else @click="postData()" >
                <span class="parkingDiscountfootButton_Span">立即申请</span>
            </div>
       </div>

        <yd-datetime style="display:none;" ref="datetime_begin" @input="dateChange" type="date" v-model="date" :startDate="curDate" :endDate="maxDate"></yd-datetime>
  </div>
</template>
<script>
import util from "@/utils/util";
import CardNumber from './components/cardNumber';
import {mapState} from 'vuex';
import {approvalMixin} from '../../utils/approvalMixin';
import{loadParkHeaderById,spaceUpPcHttp} from "../../utils/api";
import storage from '../../utils/storage';
export default {
    mixins:[approvalMixin],
    components: {
        CardNumber
    },
    computed: {
        ...mapState({
            common: state => state.common
        }),
        defaultTenant() {
            let data = this.common.userTenantInfoList || [];
            let defaultD = {};
            data.forEach(item => {
                if (item.isDeafult == 1) {
                defaultD = item;
                }
            });
            return defaultD;
        }
    },

    data(){
        return {
             approvalProcessTime:0,//发起流程次数
             startInstanceTime:0,//发起审批次数
             mustImg:2,
             cardList:'',
             plateNo:'',
             canClick:false,
             startTime:'',
             endTime:'',
             date:'',
             curDate:"",
             maxDate:'',
             userS:false,
             timeT:'',
             parkHeaderId:'',
             parkData:'',
            changeTargetIdUrl:spaceUpPcHttp+'/syscfg/attachmentTerminal/bindSomeAttachments',
            timemap:'',
            hex_md5_return:''
        }
    },
    created() {
        this.parkHeaderId =  this.$route.query.parkHeaderId;
        this.mustImg = Number(storage.getS("mustImg")) || 2//是否必传图片 1是，2否
        this.getParks();
        console.log("in created")
        this.getMDate();
        this.getMyDiscountParkLot();
    },
    mounted(){

    },
    methods:{
        toList(){
            this.$router.replace(`/discountList?&parkHeaderId=${this.parkHeaderId}`);
        },
        getMyDiscountParkLot(){
            let params =
                {
                    "subProjectId":this.common.marketInfo.id,
                    "parkHeaderId":this.parkHeaderId,
                    "phone":this.common.userInfo.account || this.common.userInfo.phone,
                    "url":"/parking/rstParkLot/loadDiscountParkLot"
                }
                loadParkHeaderById(params).then(res=>{
                    if(res.res && res.res.code === 10000 && res.body){

                    }
                })
        },

        validateParams(){
            if(!this.startTime){
                return false;
            }
            if(!this.endTime){
                return false;
            }
            if(!this.plateNo){
                return false;
            }

            return true;
        },

        postData(){
            var date1 =new Date(this.startTime);
            var date2 =new Date(this.endTime);
            if(date1>date2){
                util.showToast('开始时间不能大于结束时间')
                return;
            }

            let params = {
                "platform": "RST",
                "userId": this.common.userId,
                "userName": this.common.userTenantInfo.userName,
                "companyName":"",
                "companyId":"",
                "subProjectId": this.common.marketInfo.id,//项目id
                "phone":this.common.userInfo.account || this.common.userInfo.phone,
                "numberType": 3,//申请类型 2个人月租 3临停优惠
                "parkHeaderId": this.parkHeaderId,//车场id
                "plateNo":this.plateNo,//车牌
                applyStartDay:this.startTime.replace(/-/g,".")+' 00:00:00',
                applyEndDay:this.endTime.replace(/-/g,".")+' 23:59:59',

                // "applyStartDay": this.applyStartDay.replace(/-/g,".")+' 00:00:00',
                // "applyEndDay": this.applyEndDay.replace(/-/g,".")+' 23:59:59',
                  "url": "/parking/rstParkLot/applayDiscountParkLot"//申请零停优惠

            }
            if(this.common.userTenantInfo.id){
                 params.companyName = this.common.userTenantInfo.company,
                 params.companyId = this.common.userTenantInfo.companyId
            }
            util.showLoading('提交审核中...')
            loadParkHeaderById(params).then(res=>{
                  if(res.res && res.res.code === 10000 && res.body){
                      console.log("申请完成等等审核")
                      var prkBeans =res.body.data.prkParkLotPlateBeans;
                      if(prkBeans.length>0){
                        this.changeTarget(prkBeans[0].id)
                      }
                      //this.changeTarget(res.body.data.bsid)
                       if(res.body.data.applyStatus ==1){
                            this.approvalProcess(res.body.data,()=>{
                                //this.$router.go(-1)
                                util.hideLoading()
                            // $router.replace
                                //this.$router.push(`/discountList?&parkHeaderId=${this.parkHeaderId}`);
                                this.$router.replace(`/discountList?&parkHeaderId=${this.parkHeaderId}`);
                            },()=>{
                                util.hideLoading()
                                util.showToast('提交失败')
                            })
                        }else{
                            util.hideLoading()
                            this.$router.replace(`/discountList?&parkHeaderId=${this.parkHeaderId}`);
                        }
                  }else{
                       util.hideLoading()
                       util.showToast(res.res.msg)
                  }
            })

        },
         resetSign(){
      // 公钥+私钥+时间戳+平台
            let gong = 'vanke2019spaceup009'
            let si = '009vanke2019spaceup001'
            this.timemap = new Date().getTime()
            let platfrom = 'SaasMobile'
            let str = gong+si+this.timemap+platfrom
            this.hex_md5_return = this.$md5(str)
        },
        changeTarget(id){
            let self = this;
            this.resetSign()
            fetch(self.changeTargetIdUrl, {
                method: 'post',
                headers: {
                    'Content-Type': 'application/json',
                    "Access-channel": "saas_rst",
                    "companyId":self.common.marketInfo.cityId
                },
                body: JSON.stringify({
                    'newTarget': id,
                    'oldTarget': this.cardList[0].targetId,
                    'bizCode': 'TCP',
                    'platform': 'SaasMobile',
                    'timestamp': self.timemap,
                    'sign':self.hex_md5_return,
                    'companyId':self.common.marketInfo.cityId
                })
            }).then(response => response.json()).then(() => {

            })
        },

        getMDate(){
            console.log(" in getMDate")
             loadParkHeaderById({id: this.parkHeaderId,url:"/parking/rstParkHeader/loadMinMaxDateById"}).then(res=>{
               console.log(" in getMDate" + JSON.stringify(res))
               if(res.res && res.res.code === 10000 && res.body && res.body.data){
                    if(res.body.data.minDate){
                       this.curDate =  util.formatTime(new Date(res.body.data.minDate) ,4);
                       this.startTime =  util.formatTime(new Date() ,4);
                       this.date = util.formatTime(new Date() ,4);
                    }
                    // this.curDate =  util.formatTime(new Date() ,4);
                    //this.curDate =res.body.data.minDate
                     if(res.body.data.maxDate){
                       this.maxDate =  util.formatTime(new Date(res.body.data.maxDate),4);
                    }
                   // this.maxDate =res.body.data.maxDate
                    console.log("in getMDate   ==== " +this.curDate)
                }
              })
        },

        getParks(){
             loadParkHeaderById({subProjectId:this.common.marketInfo.id,url:"/parking/rstParkHeader/queryParkHeaderList"}).then(res=>{
                util.hideLoading()
                if(res.res && res.res.code === 10000 && res.body && res.body.data && res.body.data.length>0){
                 // this.$router.push(val.serverPath);
                    for(var i=0;i<res.body.data.length;i++){
                        var item =  res.body.data.length[i];
                        if(item.id == this.parkHeaderId){
                            this.parkData=item;
                            break;
                        }
                    }
                }else{
                  util.showModal('','项目暂未开启服务',false,'我知道了')
                }
              })
        },

        inputChange(val){
            if(val.type == 'card'){
                let cardList = val.data;
                this.cardList = cardList;
                this.plateNo = cardList[0].cardNumber
            }
            if(!this.plateNo){
                this.canClick = false
            }else{
                this.canClick = true
            }
        },
        dateChange(val){
            if(!this.userS){
                return false;
            }
            if(this.timeT == '1'){
                this.startTime = val;
            }else{
                this.endTime = val;
            }

        },

        selectTime(val){
            this.timeT = val;
            this.userS = true;
           // if(this.timeT==1){
                this.$refs.datetime_begin.open();
           // }

        }
    }

}
</script>

<style lang="less" scoped>
@import "../../assets/css/common.less";
.container{
   // height:100vh;
    background:#eee;
}
.topView{
    position: relative;
    height: 186px;
    width: 100%;
}
.cardBg{
     background:#eee;
     margin-top: 14px;
}
.topViewBg{
    position:absolute;
    left: 0px;
    top: 0px;
    height: 186px;
    width: 100%;
    z-index: 1;
}
.topViewdiv{
    position:absolute;
    left: 0px;
    top: 0px;
    height: 186px;
    width: 100%;
    z-index: 111;
    flex-direction: column;
}
.topView_item{
    flex-direction: row;
    margin-top: 40px;
     width: 100%;
     align-items: center;
     display: flex;
}
.topView_item1{
    flex-direction: row;
    margin-top: 18px;
     width: 100%;
     align-items: center;
     display: flex;
}
.topView_item_icon{
    margin-left: 30px;
    width: 36px;
    height: 36px;
    margin-right: 16px;
}
.topView_item_span{
    height:44px;
    width: 436px;
    font-size:32px;
    font-weight:500;
    color:rgba(255,255,255,1);
    line-height:44px;
     white-space: nowrap;
     overflow: hidden;
    text-overflow: ellipsis;
}
.topView_chakan{
    right: 28px;
    top: 42px;
    position: absolute;
    flex-direction: row;
    z-index: 1111;
}
.topView_chakan_span{

    height:40px;
    font-size:28px;
    font-weight:400;
    color:rgba(255,255,255,1);
    line-height:40px;
}
.topView_chakan_icon{
    margin-left: 4px;
    // margin-top: 4px;
    width: 32px;
    height: 32px;
}
.chooseDate{
     background-color: #ffffff;
}
.dateTop{
    width: 100%;
    height: 82px;
    flex-direction: row;
    align-items: center;
    display: flex;
     background:#eee;
}
.dateTop_span{
    margin-left: 28px;
    height:42px;
    font-size:30px;
    font-weight:400;
    color:rgba(153,153,153,1);
    line-height:42px;
}
.dateItem{
    width: 100%;
    height: 100px;
    display: flex;
    flex-direction: row;
    background-color: #ffffff;
}
.dateItem_left{
    width: 192px;
    height: 100px;
    flex-direction: row;
    align-items: center;
    display: flex;
}
.dateItem_left_span1{
    margin-left: 28px;
    height:42px;
    font-size:30px;
    font-weight:400;
    color:rgba(51,51,51,1);
    line-height:42px;
}
.dateItem_left_span2{
    margin-left: 4px;
    height:42px;
    font-size:30px;
    font-weight:400;
    color:rgba(252,63,86,1);
    line-height:42px;
}
.dateItem_right{
    flex-direction: row;
    display: flex;
    align-items: center;
    height: 100px;
    width: 558px;
    justify-content: space-between;
}
.dateItem_right_span1{
    margin-left: 4px;
    height:42px;
    font-size:30px;
    font-weight:400;
    color:rgba(201,201,201,1);
    line-height:42px;
}
.blackSpan{
    color: #333333;
}
.dateItem_right_span2{
    margin-left: 4px;
    height:42px;
    font-size:30px;
    font-weight:400;
    color:#333333;
    line-height:42px;
}
.dateItem_right_icon{
    margin-right: 28px;
    width: 32px;
    height: 32px;
}
.itemLine{
    margin-left: 192px;
    width:530px;
    height:2px;
    background:rgba(234,234,234,1);
}

.footButton{
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    z-index:100;
    height: 112px;
    box-sizing:border-box;
    display: flex;
    background-color: white;
    flex-direction: row;
    justify-content: space-between;
}
.footButton1_div{
    margin-top: 18px;
    margin-left: 20px;
    width:710px;
    height: 76px;
    border-radius:4px;
    display: flex;
     justify-content: center;
    align-items: center;
    background-color: #DADADA;

}
.parkingDiscountfootButton2_div{
    margin-top: 18px;
    margin-left: 20px;
    width:710px;
    height: 76px;
    border-radius:4px;
    display: flex;
     justify-content: center;
    align-items: center;
    background-color: #1740DA;

}
.parkingDiscountfootButton_Span{
    font-size:32px;
    font-weight:400;
    color:#FFFFFF;
    line-height:44px;
}


</style>